import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { Button, theme } from '@sg/garnish';

export const OrdersSeeMoreButton = (props: OrdersSeeMoreButtonProps) => {
  const { isFetchingMoreOrders, fetchMoreOrders } = props;

  return (
    <Button
      size="large-wide"
      palette="kale"
      accessibilityRole="button"
      style={styles.button}
      isLoading={isFetchingMoreOrders}
      onPress={fetchMoreOrders}
    >
      <FormattedMessage {...messages.seeMore} />
    </Button>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type OrdersSeeMoreButtonProps = Readonly<{
  isFetchingMoreOrders: boolean;
  fetchMoreOrders: () => void;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  seeMore: {
    defaultMessage: 'See more',
    description: 'Account | Orders | See more',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    minWidth: 210,
    marginHorizontal: 'auto',
    marginBottom: theme.spacing['4'],
  },
});
